import { useMemo } from "react";
import { Stack } from "@mui/material";
import { formatPhone } from "../helpers/format";
import VirtualizedTable from "../components/VirtualizeTable";

import { useNavigate } from "react-router";
import { MRT_ColumnDef } from "material-react-table";
import { IconEdit } from "@tabler/icons-react";

const ResponsibleTableComponent = ({
  data,
}: {
  data: Array<{
    id: string;
    fullName: string;
    email?: string;
    phone: string;
    createdAt: string | Date;
    status: string;
    payment: [];
    studentOnPlan: [];
    statusPayment?: string;
    statusPlan?: string;
    belts?: string;
  }>;
  refetch?: () => void;
}) => {
  const navigate = useNavigate();

  const columns = useMemo<MRT_ColumnDef<(typeof data)[0]>[]>(() => {
    return [
      {
        accessorKey: "fullName",
        header: "Nome",
      },
      {
        accessorKey: "phone",
        header: "Telefone",
        Cell: ({ cell }) => formatPhone(cell.getValue() as string),
      },
      {
        accessorKey: "status",
        header: "Status",
        enableSorting: false,
        enableColumnActions: false,
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        Cell: ({ cell }) => {
          const status = cell.getValue() as string;
          const map = {
            REGISTERED: { label: "Registrado", color: "primary.main" },
            PENDING: { label: "Pendente", color: "secondary.contrastText" },
            DISABLED: { label: "Bloqueado", color: "red" },
          };
          const { label, color } = map[status as keyof typeof map] || {
            label: status,
            color: "gray",
          };
          return (
            <Stack
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingY: 0.5,
                paddingX: 1,
                borderRadius: 5,
                backgroundColor: color,
              }}
            >
              {label}
            </Stack>
          );
        },
      },
      {
        id: "edit",
        header: "Editar",
        size: 50,
        Cell: ({ row }: any) => (
          <IconEdit
            onClick={() => navigate(`/responsaveis/${row.original.id}`)}
            style={{ cursor: "pointer", color: "#FFF" }}
          />
        ),
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
      },
    ];
  }, [data]);

  return (
    <>
      <VirtualizedTable
        data={data}
        columns={columns}
        fetchNextPage={() => Promise.resolve()}
        isLoading={false}
      />
    </>
  );
};

export default ResponsibleTableComponent;
